import { MessageCircle, Instagram, Link2, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import {
  NAV_LINKS,
  WHATSAPP_URL,
  WHATSAPP_DISPLAY,
  INSTAGRAM_URL,
  LINKTREE_URL,
  UNIDADES,
} from "../data/siteData";

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-night">
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <Logo size={46} />
          <p className="mt-5 font-display text-xl uppercase tracking-wider text-lawn">
            Treine em alto nível para jogar em alto nível
          </p>
          <p className="mt-3 text-sm leading-relaxed text-white/60">
            Escola de futebol em Patos de Minas/MG para crianças e jovens de 4 a 17 anos.
          </p>
        </div>

        <nav aria-label="Menu do rodapé">
          <h4 className="mb-4 text-xs font-bold uppercase tracking-[0.25em] text-gold">Menu</h4>
          <ul className="space-y-2.5">
            {NAV_LINKS.map((l) => (
              <li key={l.id}>
                <a
                  href={`#${l.id}`}
                  data-testid={`footer-nav-${l.id}`}
                  className="text-sm text-white/70 transition-colors hover:text-lawn"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h4 className="mb-4 text-xs font-bold uppercase tracking-[0.25em] text-gold">Unidades</h4>
          {UNIDADES.map((u) => (
            <p key={u.nome} className="mb-4 flex items-start gap-2 text-sm leading-relaxed text-white/70">
              <MapPin size={16} className="mt-0.5 shrink-0 text-lawn" />
              <span>
                <strong className="text-white">{u.nome}</strong>
                <br />
                {u.endereco}
              </span>
            </p>
          ))}
        </div>

        <div>
          <h4 className="mb-4 text-xs font-bold uppercase tracking-[0.25em] text-gold">Contato</h4>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="mb-3 flex items-center gap-2.5 text-sm text-white/70 transition-colors hover:text-lawn"
          >
            <MessageCircle size={17} className="text-lawn" /> {WHATSAPP_DISPLAY}
          </a>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            className="mb-3 flex items-center gap-2.5 text-sm text-white/70 transition-colors hover:text-gold"
          >
            <Instagram size={17} className="text-gold" /> @soccertrainerpatos
          </a>
          <a
            href={LINKTREE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-linktree-link"
            className="flex items-center gap-2.5 text-sm text-white/70 transition-colors hover:text-lawn"
          >
            <Link2 size={17} className="text-lawn" /> linktr.ee/soccertrainer
          </a>
        </div>
      </div>

      <div className="mt-14 border-t border-white/10 pt-7 text-center text-xs text-white/45">
        Soccer Trainer © 2011–2026 — Patos de Minas/MG. Todos os direitos reservados.
      </div>
    </div>
  </footer>
);

export default Footer;
